import { toolbarActions } from '../utils';
import RemoveItemsModalContent from '../components/RemoveItemsModalContent';

const FILTER_BUTTON = 0;
const REMOVE_BUTTON = 1;
const NEW_USER_BUTTON = 2;

const setupFilterButton = (toggleAdvancedFilter) => {
  toolbarActions[FILTER_BUTTON].props.onClick = toggleAdvancedFilter; 
};

const setupRemoveButton = (selectedItems, modalContext, doDeleteUsers) => {
  toolbarActions[REMOVE_BUTTON].props.disabled = !selectedItems || selectedItems.length === 0;
  toolbarActions[REMOVE_BUTTON].props.onClick = () => {
    const content = {
      component: RemoveItemsModalContent,
      props: {
        doDeleteUsers,
        selectedItems
      }
    };
    modalContext.setContent(content);
    modalContext.toggle();
  };
};

const setupNewUserButton = (history) => {
  toolbarActions[NEW_USER_BUTTON].props.onClick = () => {
    history.push('/dashboard/users/new');
  };
};

export const setupToolbarActions = (params) => {
  const { 
    history, 
    context, 
    selectedItems,
    toggleAdvancedFilter, 
    doDeleteUsers 
  } = params;

  setupFilterButton(toggleAdvancedFilter);
  setupRemoveButton(selectedItems, context, doDeleteUsers);
  setupNewUserButton(history);
};
